import React from 'react';
import { User, Target, Heart, FileText, Play } from 'lucide-react';
import SectionUnlock from '../components/SectionUnlock';

const AppealSection = ({ unlockedSections }) => {
  return (
    <section id="appeal" className="py-20 bg-gray-50 relative">
      <SectionUnlock sectionId="appeal" unlockedSections={unlockedSections}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Why NTU Computer Science?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              My passion for technology and innovation aligns perfectly with NTU's vision for the future which is innovation & out-of-the-box thinking driven by AI  which is shown by my consistent efforts to always challenge myself by going beyond classroom.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="text-center group">
              <div className="bg-blue-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 group-hover:bg-blue-200 transition-colors flex items-center justify-center">
                <User className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Group innovation and design projects in curriculum.</h3>
              <p className="text-gray-600">This excites me as peer learning resonates with my collaborative approach to problem-solving</p>
            </div>

            <div className="text-center group">
              <div className="bg-green-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 group-hover:bg-green-200 transition-colors flex items-center justify-center">
                <Target className="text-green-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Global Repuation</h3>
              <p className="text-gray-600">NTU'S strong rankings will give me a boost in the opportunities i can grab and my career as well. That would be very helpful to me.</p>
            </div>

            <div className="text-center group">
              <div className="bg-purple-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 group-hover:bg-purple-200 transition-colors flex items-center justify-center">
                <Heart className="text-purple-600" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Distance</h3>
              <p className="text-gray-600">NTU is really close to my house and its my dream university.</p>
            </div>
          </div>

          {/* <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                <FileText className="text-blue-600" size={28} />
                My Appeal Letter
              </h3>
              <p className="text-gray-600 mb-6">
                A comprehensive letter detailing my journey, achievements, and vision for the future.
              </p>
              <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center gap-2">
                <FileText size={20} />
                Download PDF
              </button>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-blue-50 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                <Play className="text-green-600" size={28} />
                Personal Message
              </h3>
              <p className="text-gray-600 mb-6">
                A 3-minute video message expressing my passion for computer science and NTU.
              </p>
              <button className="bg-green-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition-colors flex items-center gap-2">
                <Play size={20} />
                Watch Video
              </button>
            </div>
          </div> */}

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                <div className="w-3 h-3 bg-purple-600 rounded-full animate-pulse"></div>
                Final Words
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                From my first print("Hello, World!") program to complex systems,libraries and applications; 
                every project has reinforced my passion for computer science. I have genuine interest and drive to pursue this course and i hope i was able to show you this.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Through my hackathon/personal projects, school/tech clubs like Girls in Tech and etc I've demonstrated my ability to bridge the 
                gap between innovative ideas and practical solutions. NTU's Computer Science program represents 
                the perfect platform to further develop these skills. Please do re consider my merits and achievements for admission.
              </p>
            </div>
          </div>
          
          {/* Final "Ready to Launch" Section */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-12 rounded-3xl relative overflow-hidden">
              <div className="absolute inset-0 bg-black opacity-10"></div>
              <div className="relative z-10">
                <div className="text-6xl mb-6">🚀</div>
                <h3 className="text-3xl font-bold mb-4">End of Appeal 🌟</h3>
                <p className="text-xl mb-6 max-w-2xl mx-auto">
                  
                </p>
                <div className="text-2xl font-bold">
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionUnlock>
    </section>
  );
};

export default AppealSection;